import Icon from '../docs/Icon'
import { usePrefs } from '@/state/prefs'

/**
 * Light or dark. The site starts from the operating system's preference and
 * remembers the visitor's choice once they make one.
 */
export default function ThemeToggle({ className = '' }: { className?: string }) {
  const { prefs, set } = usePrefs()
  const dark = prefs.theme === 'dark'
  return (
    <button
      type="button"
      className={`mds-icon-button mds-theme-toggle ${className}`}
      aria-label="Dark theme"
      aria-pressed={dark}
      onClick={() => set('theme', dark ? 'light' : 'dark')}
    >
      <Icon name={dark ? 'moon' : 'sun'} />
    </button>
  )
}
